<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/matchclearrs")
          i.fas.fa-eraser
          span.ml-1 {{ $t("ui.match_clear_rs_rt") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="matchSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-3.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="league_name") {{ $t("ui.league_name") }}
                    b-form-radio(value="match_id") {{ $t("ui.match_id") }}
                    b-form-radio(value="sbo_match") {{ $t("ui.sbo_match") }}
                    b-form-radio(value="ibc_match") {{ $t("ui.ibc_match") }}
                div.col-md-2.mb-1
                  SubmitButton.float-right(
                    :loading="loading"
                    icon="fa fa-trash"
                    :text="$t('ui.clear_rs_rt_all')"
                    type="button"
                    @click="clearRsRtAll()"
                    variant="danger"
                    size="sm"
                    ).mr-2
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getLinkedMatchList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="linkedMatchTotalRow"
                :per-page="getPageSize"
                v-model="currentLinkedMatchPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                b-input(:value="linkedMatchTotalRow" readonly)
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width=70 @click="sortOrder('match_id')")
                        span {{ $t('ui.id') }}
                        i(:class="changeSortKey('match_id')")
                      th.sticky-position(width=70 @click="sortOrder('sport_type')")
                        span {{ $tc('ui.sports', 1) }}
                        i(:class="changeSortKey('sport_type')")
                      th.sticky-position(@click="sortOrder('league_name')")
                        span {{ $tc("ui.leagues", 1) }}
                        i(:class="changeSortKey('league_name')")
                      th.sticky-position(@click="sortOrder('home_team')")
                        span {{ $t("ui.home") }}
                        i(:class="changeSortKey('home_team')")
                      th.sticky-position(@click="sortOrder('away_team')")
                        span {{ $t("ui.away") }}
                        i(:class="changeSortKey('away_team')")
                      th.sticky-position(width=80 @click="sortOrder('match_date_time')")
                        span {{ $t("ui.short.match_date") }}
                        i(:class="changeSortKey('match_date_time')")
                      th.sticky-position(width=70)
                        span {{ $t("ui.short.match_time") }}
                      th.sticky-position(width=80)
                        span {{ $t("ui.sbo") }}
                      th.sticky-position(width=80)
                        span {{ $t("ui.ibc") }}
                      //- th.sticky-position(width=40)
                      //-   span(:title="$t('ui.affect_value')") {{ $t("ui.short.affect_value") }}
                      //- th.text-center.sticky-position(width=40)
                      //-   span {{ $t("ui.ldiff") }}
                      th.sticky-position(width=70)
                        span(:title="$t('ui.sbo_running_score')") {{ $t("ui.short.sbo_running_score") }}
                      th.sticky-position(width=85)
                        span(:title="$t('ui.sbo_running_time')") {{ $t("ui.short.sbo_running_time") }}
                      th.sticky-position(width=70)
                        span(:title="$t('ui.sbo_home_red_card')") {{ $t("ui.short.sbo_home_red_card") }}
                      th.sticky-position(width=70)
                        span(:title="$t('ui.sbo_away_red_card')") {{ $t("ui.short.sbo_away_red_card") }}
                      th.sticky-position(width=70)
                        span(:title="$t('ui.ibc_running_score')") {{ $t("ui.short.ibc_running_score") }}
                      th.sticky-position(width=85)
                        span(:title="$t('ui.ibc_running_time')") {{ $t("ui.short.ibc_running_time") }}
                      th.sticky-position(width=70)
                        span(:title="$t('ui.ibc_home_red_card')") {{ $t("ui.short.ibc_home_red_card") }}
                      th.sticky-position(width=70)
                        span(:title="$t('ui.ibc_away_red_card')") {{ $t("ui.short.ibc_away_red_card") }}
                      //- th.sticky-position(width=60)
                      //-   span {{ $t("ui.linked") }}
                  tbody.clusterize-content
                    tr(v-if="linkedMatchList.length == 0")
                      td(colspan="17").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(
                      v-for="(item, index) in linkedMatchList"
                      )
                      td
                        span(:title="item.match_id") {{ item.match_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span(:title="item.home_team") {{ item.home_team }}
                      td
                        span(:title="item.away_team") {{ item.away_team }}
                      td
                        span(:title="$moment(item.match_date).format('YYYY-MM-DD')") {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                      td
                        span(:title="item.match_time") {{ item.match_time }}
                      td
                        span(:title="item.sbo_map") {{ item.sbo_map }}
                      td
                        span(:title="item.ibc_map") {{ item.ibc_map }}
                      //- td
                      //-   span(:title="item.affect_value") {{ item.affect_value }}
                      //- td.text-center
                      //-   span
                      //-     i(:class="{'fas fa-check text-info': item.ldiff, 'fas fa-times text-warning': !item.ldiff  }")
                      td
                        span(:title="item.sbo_rs") {{ item.sbo_rs }}
                        span(v-if="item.sbo_rs")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRunningScore(item.sbo_map, 'SBO')" :title="$t('ui.clear')")
                      td
                        span(:title="item.sbo_rt") {{ item.sbo_rt }}
                        span(v-if="item.sbo_rt")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRunningTime(item.sbo_map, 'SBO')" :title="$t('ui.clear')")
                      td
                        span(:title="item.sbo_hrc") {{ item.sbo_hrc }}
                        span(v-if="item.sbo_hrc")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRedCard(item.sbo_map, 'SBO', 'h')" :title="$t('ui.clear')")
                      td
                        span(:title="item.sbo_arc") {{ item.sbo_arc }}
                        span(v-if="item.sbo_arc")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRedCard(item.sbo_map, 'SBO', 'a')" :title="$t('ui.clear')")
                      td
                        span(:title="item.ibc_rs") {{ item.ibc_rs }}
                        span(v-if="item.ibc_rs")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRunningScore(item.ibc_map, 'IBC')" :title="$t('ui.clear')")
                      td
                        span(:title="item.ibc_rt") {{ item.ibc_rt }}
                        span(v-if="item.ibc_rt")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRunningTime(item.ibc_map, 'IBC')" :title="$t('ui.clear')")
                      td
                        span(:title="item.ibc_hrc") {{ item.ibc_hrc }}
                        span(v-if="item.ibc_hrc")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRedCard(item.ibc_map, 'IBC', 'h')" :title="$t('ui.clear')")
                      td
                        span(:title="item.ibc_arc") {{ item.ibc_arc }}
                        span(v-if="item.ibc_arc")
                          a.fa.fa-trash.text-primary(href="#" @click="clearRedCard(item.ibc_map, 'IBC', 'a')" :title="$t('ui.clear')")
                      //- td
                      //-   span(:title="item.link_id") {{ item.link_id }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import $ from 'jquery';
import {resizeColumn1} from '@/main';

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    sportType: 1,
    sportList: [],
    linkedMatchList: [],
    currentLinkedMatchPage: 1,
    linkedMatchTotalRow: 0,
    matchSearch: "",
    marketType: "",
    sortKey: "league_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    filterBy: "league_name",
  }),
  computed: {
    filterCache() {
      return this.$store.getters.matchCache;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  mounted: function() {
    this.getSportList();
    this.sportType = this.filterCache.sport;
    this.linked = this.filterCache.linked;
    this.filterBy = this.filterCache.filterBy;
    this.matchSearch = this.filterCache.matchSearch;
    this.startDate = this.filterCache.startDate;
    this.endDate = this.filterCache.endDate;
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getLinkedMatchList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedFilterCache: function() {
      var json = {
        sport: this.sportType,
        matchSearch: this.matchSearch,
        linked: this.linked,
        market: this.marketType,
        filterBy: this.filterBy,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.$store.dispatch("layout/setMatchCache", json);
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchclearrs
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearRunningScore: function(matchId, providerId) {
      this.$helpers
        .alert({
          title: this.$t("ui.match_clear_rs"),
          text: this.$t("message.clear_match_rs_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmClearRunningScore(matchId, providerId);
          }
        });
    },
    confirmClearRunningScore(matchId, providerId) {
      let url = config.matchClearRsUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchclearrs,
        match_id: matchId,
        provider_id: providerId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getLinkedMatchList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearRunningTime: function(matchId, providerId) {
      this.$helpers
        .alert({
          title: this.$t("ui.match_clear_rt"),
          text: this.$t("message.clear_match_rt_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmClearRunningTime(matchId, providerId);
          }
        });
    },
    confirmClearRunningTime(matchId, providerId) {
      let url = config.matchClearRtUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchclearrs,
        match_id: matchId,
        provider_id: providerId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getLinkedMatchList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearRsRtAll: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.match_clear_rs_rt_all"),
          text: this.$t("message.clear_match_rs_rt_all_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmClearRsRtAll();
          }
        });
    },
    confirmClearRsRtAll() {
      let url = config.matchClearRSRTAllUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchclearrs
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getLinkedMatchList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearRedCard: function(matchId, providerId, team) {
      this.$helpers
        .alert({
          title: this.$t("ui.match_clear_rc"),
          text: this.$t("message.clear_match_rc_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmClearRedCard(matchId, providerId, team);
          }
        });
    },
    confirmClearRedCard(matchId, providerId, team) {
      let url = config.matchClearRcUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchclearrs,
        match_id: matchId,
        provider_id: providerId,
        team: team
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getLinkedMatchList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLinkedMatchList: function(isSearch) {
      let url = config.matchClearRsListUrl();

      if (isSearch) this.currentLinkedMatchPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.matchclearrs,
        sport_id: this.sportType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentLinkedMatchPage,
        page_size: this.getPageSize
      };

      if (this.filterBy == "match_id") {
        json.match_id = this.matchSearch;
      }
      else if (this.filterBy == "sbo_match") {
        json.sbo_match = this.matchSearch;
      }
      else if (this.filterBy == "ibc_match") {
        json.ibc_match = this.matchSearch;
      } else {
        json.league_name = this.matchSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.linkedMatchList = response.data.tbl_match_clear_rs_list;
                this.linkedMatchTotalRow = this.linkedMatchList.length > 0 ? this.linkedMatchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentLinkedMatchPage = 1;
      this.getLinkedMatchList(true);
    },
    changedPage: function(pageNo) {
      this.currentLinkedMatchPage = pageNo;
      this.getLinkedMatchList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
.custom-modal{
  position: fixed;
  z-index: 10;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: black;
  background-color: rgba(0, 0, 0, 0.4);
  margin-top: 9px;
}
.button-box{
  position: fixed;
  z-index: 999;
  background-color: #e8e8e8;
}
.pop-up-modal{
  height: auto;
  width: auto;
}
.custom-min-height01{
  min-height: 20vh;
}
</style>